import NotFound from '@/pages/errors/NotFound.vue';
import ForbiddenError from '@/pages/errors/ForbiddenError.vue';
import ServerError from '@/pages/errors/ServerError.vue';
import { DummyLayout } from '@/pages/_layout';
import type { RouteRecordRaw } from 'vue-router';

export const errorRoutes: RouteRecordRaw[] = [
    {
        path: '/403',
        name: 'error.forbidden',
        component: ForbiddenError,
        meta: {
            title: 'アクセス権限がありません',
            requiresAuth: false,
            layout: DummyLayout,
        },
    },
    {
        path: '/404',
        name: 'error.notFound',
        component: NotFound,
        meta: {
            title: 'ページが見つかりません',
            requiresAuth: false,
            layout: DummyLayout,
        },
    },
    {
        path: '/500',
        name: 'error.serverError',
        component: ServerError,
        meta: {
            title: 'サーバーエラー',
            requiresAuth: false,
            layout: DummyLayout,
        },
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'notFound',
        component: NotFound,
        meta: {
            title: 'ページが見つかりません',
            requiresAuth: false,
            layout: DummyLayout,
        },
    },
];
